import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "./mensajes2";
import { Dimmer } from "./spinner";

export const CambioClave = (props) => {
    let op = require("../../src/modulos/datos");
    const token = localStorage.getItem("jwtToken");
    const datalogin = JSON.parse(localStorage.getItem("post"));
    const login = datalogin.login;
    const idusuario = datalogin.idusuario;
    const txtContraseña = useRef();
    const txtContraseñaNueva = useRef();
    const txtConfirmar = useRef();
    const [message, setMessage] = useState("hidden");
    const [teclas, setTeclas] = useState();
    const [activate, setActivate] = useState(false);
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [mensajesino, setMensajesino] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [tipoActual, setTipoActual] = useState("password");
    const [tipoNuevo, setTipoNuevo] = useState("password");
    const [deshabilitado, setDesabilitado] = useState(true);
    const [deshabilitarBtn, setDesabilitarBtn] = useState(true);

    const cancelar = () => {
        blanquear();
        props.onHideCancelar();
    };

    const handleCloseSi = () => {
        procesarRegistro();
        setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    };

    const blanquear = () => {
        txtContraseñaNueva.current.value = "";
        txtContraseña.current.value = "";
        txtConfirmar.current.value = "";
        setDesabilitado(true);
        setDesabilitarBtn(true);
        setTipoActual("password");
        setTipoNuevo("password");
    };

    const SelectUsuario = (passwd) => {
        let endpoint = `${op.conexion}/api/comun/validarpass?passwd=${passwd}&login=${login}`;

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                app: "admin"
            },
        })
            .then((response) => {
                if (response.status == 200) {
                    setActivate(false);
                    if (response.data !== "") {
                        console.log(response.data);
                        setDesabilitado(false);
                    } else {
                        setMensaje({
                            mostrar: true,
                            titulo: "Notificacion",
                            texto: "La Contraseña es Invalida",
                            icono: "informacion",
                        });
                        txtContraseñaNueva.current.value = "";
                        txtConfirmar.current.value = "";
                        setDesabilitado(true);
                        setDesabilitarBtn(true);
                        setActivate(false);
                    }
                }
            })
            .catch((error) => {
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
                setActivate(false);
            });
    };

    const validarPropie = (event) => {
        event.preventDefault();

        if (event.which === 13 || typeof event.which === "undefined") {
            if (event.target.value !== "") {
                setTeclas(event.which);
                SelectUsuario(event.target.value);
            }
        }
    };

    const procesarRegistro = () => {
        let endpoint = `${op.conexion}/api/comun/cambioclave/`;
        setActivate(true);
        let body = {
            passwd: txtContraseñaNueva.current.value,
            login: login,
        };

        axios.post(endpoint, body, {
            headers: {
                "x-access-token": `${token}`,
                app: "admin"
            },
        })
            .then(function (response) {
                if (response.status == 200) {
                    setActivate(false);
                    setMensaje({
                        mostrar: true,
                        titulo: "Exito.",
                        texto: "La Contraseña fue cambiada.",
                        icono: "exito",
                    });
                }
            })
            .catch(function (error) {
                setActivate(false);
                setMensaje({
                    mostrar: true,
                    titulo: "Cambiar Contraseña",
                    texto: error.response.data.message,
                    icono: "error",
                });
            });
    };

    const onChangeValidar = () => {
        let sigue = true;
        if (txtContraseña.current.value === "") {
            setMensaje({
                mostrar: true,
                titulo: "Notificacion",
                texto: "La contraseña actual no debe estar vacia",
                icono: "informacion",
            });
            sigue = false;
            txtContraseña.current.focus();
        } else if (txtContraseñaNueva.current.value === "") {
            setMensaje({
                mostrar: true,
                titulo: "Notificacion",
                texto: "La Contraseña nueva no debe estar vacia",
                icono: "informacion",
            });
            sigue = false;
            txtContraseñaNueva.current.focus();
        } else if (txtConfirmar.current.value === "") {
            setMensaje({
                mostrar: true,
                titulo: "Notificacion",
                texto: "Debe Confirmar la Contraseña ",
                icono: "informacion",
            });
            sigue = false;
            txtConfirmar.current.focus();
        }

        if (sigue) {
            setMensajesino({
                mostrar: true,
                titulo: "Confirmación.",
                texto: "Esta seguro de Cambiar su contraseña?",
                icono: "confirmacion",
            });
        }
    };

    const onChange = (e) => {
        if (e.target.name === "confirmar") {
            if (
                txtContraseñaNueva.current.value.trim() ===
                txtConfirmar.current.value.trim()
            ) {
                setMessage("hidden");
                setDesabilitarBtn(false);
            } else {
                setMessage("visible");
                setDesabilitarBtn(true);
            }
        }
    };

    const verClave = (tipo) => (e) => {
        e.preventDefault();
        if (tipo === 1) {
            if (tipoActual === "password") {
                setTipoActual("text");
            } else {
                setTipoActual("password");
            }
        } else if (tipo === 2) {
            if (tipoNuevo === "password") {
                setTipoNuevo("text");
            } else {
                setTipoNuevo("password");
            }
        }
    };
    const cerrarModal = () => {
        props.render();
        blanquear();
        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    };

    useEffect(() => { }, []);
    //console.log(values)

    return (
        <Modal
            show={props.show}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            contentClassName="border-0 shadow-lg rounded"
            onShow={() => setTimeout(() => txtContraseña.current && txtContraseña.current.focus(), 150)}
        >
            <Modal.Header className="azulGradiant border-0 py-3 px-4">
                <div className="d-flex align-items-center">
                    <div
                        className="rounded-circle bg-white mr-3 d-flex align-items-center justify-content-center"
                        style={{ width: 44, height: 44, color: "#0a5a8f" }}
                    >
                        <i className="fas fa-key fs-5"></i>
                    </div>
                    <div>
                        <h3 className="font-weight-bold text-white mb-0" id="contained-modal-title-vcenter">
                            Cambiar Contraseña
                        </h3>
                        <small className="text-white-50">Proteja su cuenta actualizando su clave</small>
                    </div>
                </div>
                <button
                    type="button"
                    className="close bg-transparent border-0"
                    style={{ color: "#ffffff", fontSize: "1.5rem", lineHeight: 1, opacity: 1 }}
                    aria-label="Cerrar"
                    onClick={cancelar}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </Modal.Header>

            <Modal.Body className="px-4 py-4">
                <Dimmer active={activate} />

                {/* Datos del usuario */}
                <div className="d-flex align-items-center bg-light border rounded px-3 py-2 mb-4">
                    <div
                        className="rounded-circle azulGradiant text-white mr-3 d-flex align-items-center justify-content-center"
                        style={{ width: 38, height: 38 }}
                    >
                        <i className="fas fa-user"></i>
                    </div>
                    <div>
                        <small className="text-muted text-uppercase d-block" style={{ fontSize: "0.7rem" }}>
                            Usuario
                        </small>
                        <span className="font-weight-bold" style={{ color: "#0a5a8f" }}>
                            {login}
                        </span>
                    </div>
                </div>

                {/* Contraseña actual */}
                <div className="mb-3">
                    <label htmlFor="txtContrasenaActual" className="form-label font-weight-bold text-uppercase small mb-1">
                        Contraseña actual
                        {!deshabilitado && (
                            <i className="fas fa-check-circle text-success ml-2" title="Contraseña correcta"></i>
                        )}
                    </label>
                    <div className="input-group input-group-sm">
                        <div className="input-group-prepend">
                            <span className="input-group-text bg-white">
                                <i className="fas fa-lock text-secondary"></i>
                            </span>
                        </div>
                        <input
                            id="txtContrasenaActual"
                            type={tipoActual}
                            className="form-control"
                            placeholder="Ingrese su contraseña actual"
                            name="passw"
                            ref={txtContraseña}
                            onKeyUp={validarPropie}
                            onBlur={validarPropie}
                            autoComplete="current-password"
                        />
                        <div className="input-group-append">
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={verClave(1)}
                                title={tipoActual === "password" ? "Mostrar contraseña" : "Ocultar contraseña"}
                            >
                                <i className={`fas ${tipoActual === "password" ? "fa-eye" : "fa-eye-slash"}`}></i>
                            </button>
                        </div>
                    </div>
                </div>

                <hr className="my-3" />

                {/* Contraseña nueva */}
                <div className="mb-3">
                    <label htmlFor="txtContrasenaNueva" className="form-label font-weight-bold text-uppercase small mb-1">
                        Contraseña nueva
                    </label>
                    <div className="input-group input-group-sm">
                        <div className="input-group-prepend">
                            <span className="input-group-text bg-white">
                                <i className="fas fa-key text-secondary"></i>
                            </span>
                        </div>
                        <input
                            id="txtContrasenaNueva"
                            type={tipoNuevo}
                            className="form-control"
                            placeholder="Ingrese la nueva contraseña"
                            ref={txtContraseñaNueva}
                            disabled={deshabilitado}
                            autoComplete="new-password"
                        />
                        <div className="input-group-append">
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                disabled={deshabilitado}
                                onClick={verClave(2)}
                                title={tipoNuevo === "password" ? "Mostrar contraseña" : "Ocultar contraseña"}
                            >
                                <i className={`fas ${tipoNuevo === "password" ? "fa-eye" : "fa-eye-slash"}`}></i>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Confirmar contraseña */}
                <div className="mb-3">
                    <label htmlFor="txtConfirmar" className="form-label font-weight-bold text-uppercase small mb-1">
                        Confirmar contraseña
                    </label>
                    <div className="input-group input-group-sm">
                        <div className="input-group-prepend">
                            <span className="input-group-text bg-white">
                                <i className="fas fa-check-double text-secondary"></i>
                            </span>
                        </div>
                        <input
                            id="txtConfirmar"
                            type={tipoNuevo}
                            className="form-control"
                            placeholder="Repita la nueva contraseña"
                            name="confirmar"
                            ref={txtConfirmar}
                            disabled={deshabilitado}
                            onKeyUp={onChange}
                            autoComplete="new-password"
                        />
                    </div>
                    <div
                        className="d-flex align-items-center justify-content-center text-danger font-weight-bold small mt-2"
                        style={{ visibility: message }}
                    >
                        <i className="fas fa-exclamation-triangle mr-1"></i>
                        <span>Las contraseñas no coinciden.</span>
                    </div>
                </div>

                {/* Recomendaciones de seguridad */}
                <div className="d-flex border border-info rounded p-3" style={{ backgroundColor: "#f0f9ff" }}>
                    <i className="fas fa-info-circle text-info mt-1 mr-2"></i>
                    <div className="small text-secondary">
                        <span className="font-weight-bold d-block mb-1">Recomendaciones de seguridad:</span>
                        <ul className="mb-0 pl-3" style={{ lineHeight: 1.7 }}>
                            <li>Use una contraseña de al menos 6 caracteres.</li>
                            <li>Combine letras mayúsculas, minúsculas y números.</li>
                            <li>Evite usar información personal fácil de adivinar.</li>
                        </ul>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-end bg-light border-top px-4 py-3">
                <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm rounded-pill px-4 mr-2"
                    onClick={cancelar}
                >
                    <i className="fas fa-times mr-1"></i>Cancelar
                </button>
                <button
                    type="button"
                    className="btn btn-success btn-sm rounded-pill px-4 shadow-sm"
                    onClick={onChangeValidar}
                    disabled={deshabilitarBtn}
                >
                    <i className="fas fa-check mr-1"></i>Aceptar
                </button>
            </Modal.Footer>
            <Mensaje
                mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === "Exito."
                        ? cerrarModal()
                        : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
                }}
            />
            <MensajeSiNo
                mensaje={mensajesino}
                onHideNo={() =>
                    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
                }
                onHideSi={handleCloseSi}
            />
        </Modal>
    );
};
